import { Monitor, Moon, Sun, type LucideIcon } from "lucide-react";

import type { MessageId } from "@/shared/i18n/messages";
import { THEME_PREFERENCES, type ThemePreference } from "@/shared/theme/theme";

export interface ThemeOption {
  value: ThemePreference;
  labelId: MessageId;
  icon: LucideIcon;
}

/** The three choices, in the order every theme switch shows them. */
export const THEME_OPTIONS: readonly ThemeOption[] = THEME_PREFERENCES.map((value) => ({
  value,
  labelId: `theme.${value}`,
  icon: { system: Monitor, light: Sun, dark: Moon }[value],
}));
